<template>
  <div class="card-password-content" style="position: relative"
       :class="{'not-editable':editSection !== '' && editSection !== title}">
    <b-loading :active="editSection !== '' && editSection !== title"
               animation="unset" :is-full-page="false">
      <slot>{{''|upper}}</slot>
    </b-loading>
    <template v-if="editSection!=='Password'">
      <p>We recommend changing your password every 3-6 months. You should change password
        immediately if someone else knows it.</p>
      <div class="personal-card-controls">
        <button class="button is-success"
                @click="$emit('edit-card', 'Password')">{{'change password' | upper}}</button>
      </div>
    </template>
    <template v-else>
      <validation-observer v-slot="{ handleSubmit, reset }">
        <form autocomplete="off"
              @reset.prevent="setSectionNotEditable(reset)"
              @submit.prevent="handleSubmit(submitPasswordChange)">
          <field name="Password"
                 placeholder="Keep unchanged"
                 class="field-password"
                 v-model.trim="password"
                 type="password"
                 :password-reveal="password.length > 0"
                 :tooltip="passwordHint"
                 tooltip-classes="is-gray"
                 icon-pack="fa"
                 editable
                 :rules="{
                   min_password_length:8,
                   lower_case_letter: true,
                   upper_case_letter: true,
                   numeric_letter: true,
                   password: true,
                 }"
                 maxlength="32"><template v-slot:raw>********</template>
          </field>
          <div class="buttons">
            <button class="button button-cancel" type="reset">Cancel</button>
            <button class=" button is-success" type="submit">Submit</button>
          </div>
        </form>
      </validation-observer>
    </template>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapMutations } from 'vuex';
import * as MUTATIONS from '@/store/mutations';
import * as USER_ACTIONS from '@/store/modules/user/actions';
import Field from '../../../Field.vue';

export default {
  name: 'CardPassword',
  components: {
    Field,
  },
  props: {
    editSection: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      id: null,
      password: '',
    };
  },
  watch: {
    /** Hack, for run computed.stateToLocal */
    stateToLocal() {
      // pass
    },
  },
  computed: {
    ...mapGetters(['passwordHint']),
    stateToLocal() {
      return Object.keys(this.$store.state.user).forEach((key) => {
        this[key] = this.$store.state.user[key];
      });
    },
  },
  methods: {
    ...mapMutations({ preloader: MUTATIONS.SET_PRELOADER }),
    ...mapActions('user', {
      updatePassword: USER_ACTIONS.UPDATE_PASSWORD,
    }),

    setSectionNotEditable(reset = null) {
      if (typeof reset === 'function') reset();

      this.password = '';
      this.$emit('edit-card', '');
    },
    submitPasswordChange() {
      if (!this.password) {
        this.setSectionNotEditable();
        return;
      }
      this.updatePassword({ id: this.id, password: this.password })
        .then(() => {
          this.$buefy.toast.open({ message: 'Update successful!', type: 'is-success' });
          this.setSectionNotEditable();
        }).catch((error) => {
          const message = this.lodash.get(error, 'response.data.message',
            'An unexpected error occurred, please contact support@enhancify.com');
          this.$buefy.snackbar.open({
            message,
            position: 'is-top',
            indefinite: true,
            actionText: ' ',
            type: 'is-danger',
          });
        });
    },
  },
  deactivated() {
    this.setSectionNotEditable();
  },
};
</script>

<style lang="stylus" scoped>
.field-password >>> input[type="password"]::-ms-reveal
  display none
.card-password-content
  color #525F66
  display flex
  height 220px
  padding-top 15px
  flex-direction column
  justify-content space-between
  &>span
    height 100%
    form
      height 100%
      display flex
      flex-direction column
      justify-content space-between
      div.buttons
        justify-content end
  >>>.personal-info__field-label
    font-weight 400
    color #8A9499
  >>> .field.personal-info__field
    input
      height 48px
      color #293033
    span.icon
      height 100%
.card-password-content >>> .b-tooltip::after
  @media screen and (min-width 340px)
    width 300px!important
    left 60px

.field-password >>> span.icon.has-text-primary i.mdi
  color gray
.field-password >>> .label span:after
  white-space pre-line
  text-align left
button.button
  min-width 135px
  height 48px
  border 1px solid #23D160
  font-size 19px
  text-transform uppercase
.button.is-success
  border none
.button.button-cancel
  color #23D160
.button.button-cancel:hover
  background #17b548
  color white
.personal-card-controls
  width 100%
  display flex
  justify-content right
.loading-overlay >>> .loading-background
  background rgba(255,255,255,0.8)

</style>
